const themeConfig = {
  cloverleaf: {
    brand: {
      size: 96
    }
  }
};
module.exports = themeConfig;
